import { colors } from '@nettbureau/vibrant-ui';
import { useTranslate } from '@tolgee/react';
import { useEffect } from 'react';
import { buildInfowindowContent } from '../build-info-window-content';
import { MarkerDefinition } from '../GoogleMap';

const DEFAULT_ZOOM = 11;

export interface UseInitMarkersProps {
  map?: google.maps.Map;
  markerDefinitions: MarkerDefinition[];
}

export function useInitMarkers({
  map,
  markerDefinitions,
}: UseInitMarkersProps) {
  const { t } = useTranslate();

  useEffect(() => {
    if (!map) return;

    markerDefinitions.forEach((marker) => {
      if (marker.infoWindow) {
        marker.infoWindow.close();
      }
    });

    const bounds = new google.maps.LatLngBounds();

    markerDefinitions.forEach((markerDefinition) => {
      try {
        const position = {
          lat: markerDefinition.lat,
          lng: markerDefinition.lng,
        };

        markerDefinition.infoWindow = new google.maps.InfoWindow({
          headerDisabled: true,
        });

        markerDefinition.marker = new google.maps.marker.AdvancedMarkerElement({
          map,
          position,
          title: markerDefinition.name,
          content: new google.maps.marker.PinElement(
            markerDefinition.color === 'red'
              ? {
                  background: colors.red[400],
                  borderColor: colors.red[600],
                  glyphColor: colors.red[600],
                }
              : {
                  background: colors.gray[300],
                  borderColor: colors.gray[500],
                  glyphColor: colors.gray[500],
                },
          ).element,
        });

        markerDefinition.marker?.addListener('click', () => {
          markerDefinitions.forEach((marker) => {
            marker.infoWindow?.close();
          });

          const infoWindowElement = document.createElement('div');

          markerDefinition.infoWindow?.setContent(infoWindowElement);
          markerDefinition.infoWindow?.open(map, markerDefinition.marker);

          buildInfowindowContent(
            infoWindowElement,
            markerDefinition,
            t('more_information'),
          );
        });

        bounds.extend(position);
      } catch (e) {
        console.error(e);
      }
    });

    markerDefinitions.length === 1
      ? map.setZoom(DEFAULT_ZOOM)
      : map.fitBounds(bounds);
  }, [markerDefinitions, map]);
}
